import {openResourceModal} from '../../core/modalCommand';
import {reportActiveAgentModalLifecycle} from '../../core/modalLifecycle';
import {
	SITE_CLONE_MODAL_EVENT,
	SITE_CONFIGURE_MODAL_EVENT,
	SITE_CREATE_MODAL_EVENT,
	SITE_DELETE_MODAL_EVENT,
	SITE_EDIT_MODAL_EVENT,
	SITE_IMPORT_MODAL_EVENT,
	SITE_RADIO_MODAL_EVENT,
} from './events';

/**
 * Open Add Site.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSiteCreateModal(command, envelope) {
	return openResourceModal(SITE_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open the Site identity editor.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSiteEditModal(command, envelope) {
	return openResourceModal(SITE_EDIT_MODAL_EVENT, command, envelope);
}

/**
 * Open Site configuration.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSiteConfigureModal(command, envelope) {
	return openResourceModal(SITE_CONFIGURE_MODAL_EVENT, command, envelope);
}

/**
 * Open the Site delete confirmation.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSiteDeleteModal(command, envelope) {
	return openResourceModal(SITE_DELETE_MODAL_EVENT, command, envelope);
}

/**
 * Open Clone Site.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSiteCloneModal(command, envelope) {
	return openResourceModal(SITE_CLONE_MODAL_EVENT, command, envelope);
}

/**
 * Open Import Site Configuration.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSiteImportConfigurationModal(command, envelope) {
	return openResourceModal(SITE_IMPORT_MODAL_EVENT, command, envelope);
}

/**
 * Open the Site radio settings.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSiteRadioModal(command, envelope) {
	return openResourceModal(SITE_RADIO_MODAL_EVENT, command, envelope);
}

/**
 * Report a Site UI outcome to the active workflow.
 * @param {'modal.cancelled'|'modal.saved'} eventType lifecycle event
 * @return {Promise<object|null>} agent response
 */
export function reportSiteModalLifecycle(eventType) {
	return reportActiveAgentModalLifecycle(eventType);
}
